export default "7b68b94ffe239f30.svg"